import * as UserModule from 'Modules/UserModule';
import * as AuthModule from 'Modules/AuthModule';
import { User } from '../EnumTypes/ActionEnumTypes';
import { toast } from 'react-toastify';

export const success = (data) => ({
  type: User.CHANGE_USER_EMAIL_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: User.CHANGE_USER_EMAIL_FAILURE,
});

const changeUserEmail = (values) => async (dispatch) => {
  const id = toast.loading('Trwa zmiana nazwy...');
  try {
    const response = await UserModule.Connector.changeUserEmail(values);
    toast.update(id, {
      render: 'Email został zmieniony',
      type: toast.TYPE.SUCCESS,
      isLoading: false,
      closeButton: true,
      autoClose: 3000,
    });
    dispatch(AuthModule.Actions.getAuthorizedUser());
    dispatch(success(response.data.user));
    return true;
  } catch (err) {
    toast.update(id, {
      render: 'Nie udało się zmienić emaila',
      type: toast.TYPE.ERROR,
      isLoading: false,
      closeButton: true,
      autoClose: 3000,
    });
    dispatch(failure());
    return false;
  }
};

export default changeUserEmail;
